import React from 'react';
import styled from 'styled-components';
import ReactSlider from 'react-slider';

interface Props {
  scale: number;
  sliderColor: 'orange' | 'green';
  onChange(value: number): void;
}

const ZoomController = ({ scale, sliderColor, onChange }: Props) => {
  return (
    <div>
      <StyledSlider
        className="horizontal-slider"
        marks
        markClassName="example-mark"
        defaultValue={scale ?? 2}
        min={0}
        max={4}
        renderMark={Mark}
        renderTrack={Track}
        renderThumb={sliderColor === 'orange' ? ThumbOrange : ThumbGreen}
        onChange={value => {
          if (typeof value === 'number') onChange(value);
          else onChange(0);
        }}
      />
    </div>
  );
};
export default ZoomController;

const StyledSlider = styled(ReactSlider)`
  width: 100%;
  height: 29px;
`;

const StyledMark = styled.div`
  height: 10px;
  margin: 10px 0;
  line-height: 29px;
  width: 29px;
  text-align: center;
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0) calc(50% - 2px),
    rgba(192, 192, 192, 1) calc(50%),
    rgba(0, 0, 0, 0) calc(50% + 2px)
  );
  cursor: grab;
`;

const Mark = (props: any): JSX.Element | null => <StyledMark {...props} />;

const StyledThumbGreen = styled.div<{ color: string }>`
  height: 29px;
  line-height: 29px;
  width: 29px;
  text-align: center;
  background-color: #fff;
  color: #000;
  border: 1px solid #3fcc99;
  border-radius: 50%;
  cursor: grab;
`;

const ThumbGreen = (props: any) => <StyledThumbGreen {...props} />;

const StyledThumbOrange = styled.div<{ color: string }>`
  height: 29px;
  line-height: 29px;
  width: 29px;
  text-align: center;
  background-color: #fff;
  color: #000;
  border: 1px solid #ff8d00;
  border-radius: 50%;
  cursor: grab;
`;

const ThumbOrange = (props: any) => <StyledThumbOrange {...props} />;

const StyledTrack = styled.div`
  margin: 0 14px;
  top: 0;
  bottom: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) calc(50% - 1px),
    rgba(192, 192, 192, 1) calc(50%),
    rgba(0, 0, 0, 0) calc(50% + 1px)
  );
`;

const Track = (props: any, state: any) => (
  <StyledTrack {...props} index={state.index} />
);
